<template>
    <!-- Settings page body: the Settings pages rail on the left (hidden on mobile, where the nav menu has them),
         the page's own content beside it, left aligned on the page background -->
    <div class="settings-wrap">
        <!-- Not a <nav>: style.scss styles every nav as the side menu -->
        <div class="settings-rail" role="navigation" aria-label="Settings">
            <router-link v-for="link in links" :key="link.to" :to="link.to" :class="['settings-rail-item', { on: $route.path == link.to }]">
                <svg-icon :icon="link.icon" />{{ link.label }}
            </router-link>
        </div>
        <div class="settings-panel">
            <p v-if="desc" class="settings-desc">{{ desc }}</p>
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { settingsLinks } from '@/settingsNav';

export default defineComponent({
    name: 'SettingsLayout',
    components: {
        SvgIcon
    },
    props: {
        desc: { type: String, default: '' }
    },
    computed: {
        links(): any[] {
            return settingsLinks(this.$store.state.user);
        }
    }
});
</script>
